var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="post-like-list" style="display: none">\n    <div class="post-like-list__avatars"></div>\n\n    <div class="post-like-list__info">\n        <div class="js-likes-tooltip tooltip tooltip--day tooltip--no-max-width">\n            <span class="tooltip-trigger js-tooltip-trigger link--quiet qa-total-likes-count">\n                '+
((__t=( numberOfLikes ? numberOfLikesLabel : '' ))==null?'':_.escape(__t))+
'\n            </span>\n\n            <div class="tooltip__content js-tooltip-content">\n\n                <div class="post-like-list__complete-list"></div>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n';
}
return __p;
};
